// controllers/local_time_controller.js
import { Controller } from "@hotwired/stimulus"
import { DateTime } from "luxon"

// Two modes:
// - default: a ticking clock showing the current time in `timezone`
// - fixed:   pass `time` (ISO 8601) to render that instant in `timezone`
//            (defaults to the browser's zone) — no interval needed
export default class extends Controller {
  static values = {
    time: { type: String, default: "" },
    timezone: { type: String, default: Intl.DateTimeFormat().resolvedOptions().timeZone },
    format: { type: String, default: "h:mm:ss a" },
    interval: { type: Number, default: 1000 } // update every second
  }

  connect() {
    this.update()
    if (!this.timeValue) {
      this.timer = setInterval(() => this.update(), this.intervalValue)
    }
  }

  disconnect() {
    clearInterval(this.timer)
  }

  update() {
    const base = this.timeValue ? DateTime.fromISO(this.timeValue) : DateTime.now()
    this.element.textContent = base.setZone(this.timezoneValue).toFormat(this.formatValue)
  }
}
